import React from 'react';

function ServicesHomeOne({ className }) {
    return (
        <section className={`appie-service-area pt-90 pb-100 ${className}`} id="service">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-6">
                        <div className="appie-section-title text-center">
                            <h3 className="appie-title">Fonctionnalités majeures</h3>
                            <p>
                                La simplicité des fonctionnalités fait de Gmee un réseau vraiment
                                convivial ✌️
                            </p>
                        </div>
                    </div>
                </div>
                <div
                    className="row"
                    style={{
                        justifyContent: 'center',
                    }}
                >
                    <div className="col-lg-3 col-md-6">
                        <div
                            className="appie-single-service text-center mt-30 wow animated fadeInUp"
                            data-wow-duration="2000ms"
                            data-wow-delay="200ms"
                        >
                            <div className="icon">
                                <i
                                    className="gif3 gif3-quote"
                                    style={{
                                        color: 'white',
                                        fontSize: '2.5rem',
                                        marginTop: '1rem',
                                    }}
                                />
                                <span>1</span>
                            </div>
                            <h4 className="appie-title">Gmeet</h4>
                            <p>Plutôt Gmeet normal ou en mode citation ?</p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div
                            className="appie-single-service text-center mt-30 item-2 wow animated fadeInUp"
                            data-wow-duration="2000ms"
                            data-wow-delay="400ms"
                        >
                            <div className="icon">
                                <i
                                    className="gif3 gif3-chat"
                                    style={{
                                        color: 'white',
                                        fontSize: '2.5rem',
                                        marginTop: '1rem',
                                    }}
                                />
                                <span>2</span>
                            </div>
                            <h4 className="appie-title">Chat</h4>
                            <p>En tête à tête ou à plusieurs, discutez différemment</p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div
                            className="appie-single-service text-center mt-30 item-3 wow animated fadeInUp"
                            data-wow-duration="2000ms"
                            data-wow-delay="600ms"
                        >
                            <div className="icon">
                                <i
                                    className="gif3 gif3-color"
                                    style={{
                                        color: 'white',
                                        fontSize: '2.5rem',
                                        marginTop: '1rem',
                                    }}
                                />
                                <span>3</span>
                            </div>
                            <h4 className="appie-title">Personnalisation</h4>
                            <p>Envie d'une autre couleur principale ? C'est possible !</p>
                        </div>
                    </div>
                    {/* <div className="col-lg-3 col-md-6">
                        <div
                            className="appie-single-service text-center mt-30 item-4 wow animated fadeInUp"
                            data-wow-duration="2000ms"
                            data-wow-delay="800ms"
                        >
                            <div className="icon">
                                <img src={IconFour} alt="" />
                                <span>4</span>
                            </div>
                            <h4 className="appie-title">Suporting</h4>
                            <p>Mucker plastered bugger all mate morish are.</p>
                        </div>
                    </div> */}
                </div>
            </div>
        </section>
    );
}

export default ServicesHomeOne;
